import { Component } from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifIconModule } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-coa-instructions',
  standalone: true,
  imports: [MotifIconModule],
  templateUrl: './coa-instructions.component.html',
  styleUrl: './coa-instructions.component.scss',
})
export class CoAInstructionsComponent {
  IconoirInfoCircle = IconoirInfoCircle;
}
